import { TypeOfFields } from './form_builder_iterfaces';

export const FONT_FAMILIES = [
    { value: 'inherit', label: 'default' },
    { value: 'Arial, sans-serif', label: 'Arial' },
    { value: 'Times New Roman, serif', label: 'Times New Roman' },
    { value: 'Helvetica, sans-serif', label: 'Helvetica' },
    { value: 'Courier New, monospace', label: 'Courier New' },
    { value: 'Georgia, serif', label: 'Georgia' },
    { value: 'Verdana, sans-serif', label: 'Verdana' },
    { value: 'Impact, sans-serif', label: 'Impact' },
    { value: 'Roboto, sans-serif', label: 'Roboto' }
];

export const HEADINGS = [
    { value: 'h1', label: 'Heading 1' },
    { value: 'h2', label: 'Heading 2' },
    { value: 'h3', label: 'Heading 3' },
    { value: 'h4', label: 'Heading 4' },
    { value: 'h5', label: 'Heading 5' },
    { value: 'h6', label: 'Heading 6' }
];

export const BTN_SIZE = [
    { value: 'small', label: 'Small' },
    { value: 'medium', label: 'Medium' },
    { value: 'large', label: 'Large' },
    { value: 'extra-large', label: 'Extra Large' }
];

export const ALIGN_SIZE = [
    { value: 'left', label: 'Left' },
    { value: 'center', label: 'Center' },
    { value: 'right', label: 'Right' }
];

export const getDefaultPlaceholder = (type: TypeOfFields | string) => {
    switch (type) {
        case 'phone': return 'e.g +1 (123) 456-7890';
        case 'decimal': return 'e.g 0.00';
        case 'percentage': return 'e.g 0%';
        case 'currency': return 'e.g 0.00';
        case 'date': return 'MM/DD/YYYY';
        case 'checkbox':
        case 'radio':
        case 'rating':
        case 'slider':
        case 'file':
        case 'image':
            return '';
        default: return `Enter ${type.charAt(0).toUpperCase() + type.slice(1)}`;
    }
};